export const BASEURL = process.env.REACT_APP_SERVICE_URL;
export const IMAGEPATH = process.env.IMAGE_BASE_URL;

export const PAGE_SIZE = 10;
export const CURRENT_PAGE = 1;
